/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link, Redirect } from 'react-router-dom';
import MainHeader from '../header';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';

class Register extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.testing);
        this.state = {firstName: "", lastName: "", email: "", username: "", password: "", redirecting: "", redirecting: "", provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleFirstName= this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUsername = this.handleUsername.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.register = this.register.bind(this);
    }

    handleFirstName(e) {
        this.setState({firstName: e.target.value});
    }

    handleLastName(e) {
        this.setState({lastName: e.target.value});
    }

    handleEmail(e) {
        this.setState({email: e.target.value});
    }

    handleUsername(e) {
        this.setState({userName: e.target.value});
    }

    handlePassword(e) {
        this.setState({password: e.target.value});
    }


    register(e) {
        const globalThis = this;
        const customer = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber
        };

        $.ajax({
            url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/register',
            type: 'post',
            async: false,
            data: {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                username: this.state.userName,
                email: this.state.email,
                password: this.state.password
            },
            error: function (response) {
                //Failed response
                // logOrderError(visitID, 'otsError', completeOrderData, response);
            },
            success: function (response) {
                if(typeof(response) === "object") {
                    if(typeof(response.message) !== "undefined") {
                        if(response.message.indexOf("token_generated") > -1) {
                            if(typeof(response.data) !== "undefined") {
                                let token = response.data.token;
                                localStorage.setItem("mealToken", token);

                                globalThis.setState(prevState => ({
                                    redirecting: <Redirect to="/feed"/>
                                }));
                            }
                        }
                    }
                }

            }
        });

    }

    componentWillMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }

        // //TESTING COMPLETE ORDERS


        //TESTING COMPLETE ORDERS
        // $.ajax({
        //     url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
        //     type: 'get',
        //     async: false,
        //     'headers': {
        //         // Use access_token previously retrieved from inContact token
        //         // service.
        //         'Authorization': 'Bearer ' + "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjEsImlzcyI6Imh0dHA6XC9cL2xvY2FsaG9zdDo4MDAwXC9hcGlcL2F1dGhcL2xvZ2luIiwiaWF0IjoxNTE0MTAwMzY0LCJleHAiOjE1MTQxMDM5NjQsIm5iZiI6MTUxNDEwMDM2NCwianRpIjoiTUtrYzc1UmtTNHAxMnNzYSJ9.bkevEDQDy8rbhuRW1nO-yGd2XRlTeK6OumLTgeBw_eA",
        //     },
        //     data: {
        //         email: "johndoe@example.com",
        //         password:"johndoe"
        //     },
        //     error: function (response) {
        //         //Failed response
        //         // logOrderError(visitID, 'otsError', completeOrderData, response);
        //     },
        //     success: function (response) {
        //         console.log(response);
        //     }
        // });

    }

    //TODO set referrer url link in containers first child link
    render() {

        let output =             <div>
            <MainHeader/>

            <div className="panel panel-default">
                <div className="panel-heading text-center"><h3>Login to see your meals!</h3></div>

                <div className="panel-body">
                    <ReactBootstrap.Form horizontal ethod="POST" action={'https://' + document.domain + '/login'}>
                        <div className="info1-widget">
                            <div className="info-top clearfix">
                                {/*<!--<h3 className="pull-left"><span>3</span> Enter Customer's Information</h3>-->*/}
                                <h3 className="pull-left"><span>1</span> Register below to create a Mealtrist account! </h3>
                            </div>
                            <div className="inner clearfix">

                                <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalFirstName">
                                    <ReactBootstrap.Col lg={3}>
                                    </ReactBootstrap.Col>
                                    <ReactBootstrap.Col lg={6}>
                                        <ReactBootstrap.FormControl type="firstName" onChange={this.handleFirstName} placeholder="First Name" />
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.FormGroup>
                                <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalLastName">
                                    <ReactBootstrap.Col lg={3}>
                                    </ReactBootstrap.Col>
                                    <ReactBootstrap.Col lg={6}>
                                        <ReactBootstrap.FormControl type="lastName" onChange={this.handleLastName} placeholder="Last Name" />
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.FormGroup>
                                <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalUsername">
                                    <ReactBootstrap.Col lg={3}>
                                    </ReactBootstrap.Col>
                                    <ReactBootstrap.Col lg={6}>
                                        <ReactBootstrap.FormControl type="userName" onChange={this.handleUsername} placeholder="Username" />
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.FormGroup>
                                <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalName">
                                    <ReactBootstrap.Col lg={3}>
                                    </ReactBootstrap.Col>
                                    <ReactBootstrap.Col lg={6}>
                                        <ReactBootstrap.FormControl type="email" onChange={this.handleEmail} placeholder="Email" />
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.FormGroup>
                                <ReactBootstrap.FormGroup bsSize="large" controlId="formGroupPhone">
                                    <ReactBootstrap.Col lg={3}>
                                    </ReactBootstrap.Col>
                                    <ReactBootstrap.Col lg={6}>
                                        <ReactBootstrap.FormControl type="password" onChange={this.handlePassword} placeholder="Password" />
                                    </ReactBootstrap.Col>
                                </ReactBootstrap.FormGroup>
                                <ReactBootstrap.FormGroup bsSize="large" controlId="formGroupPhone">
                                    <ReactBootstrap.Col lg={3}>
                                    </ReactBootstrap.Col>
                                    <ReactBootstrap.Col lg={6}>
                                        <ReactBootstrap.Button onClick={this.register} bsStyle="primary" bsSize="large" block>Register</ReactBootstrap.Button>
                                    </ReactBootstrap.Col>>
                                </ReactBootstrap.FormGroup>
                            </div>
                        </div>
                    </ReactBootstrap.Form>
                </div>
            </div>

        </div>

        if(this.state.redirecting !== "" ) {
            output = this.state.redirecting;
        }
        return (
            output
        );
    }
}

export default Register;


// WEBPACK FOOTER //
// ./src/components/Authentication/register.js